import PropertyAdForm from "../../../../components/forms/propertyAdform";
import { useState, useEffect } from "react";
import { SuccessNotify, FailedNotify } from "../../../../constants/tostify";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux/es/exports";
import { useLazyGetShopConsumerCategoriesQuery } from "../../../../features/shop/shopApiSlice";
import { useCreatePropertyMutation } from "../../../../features/property/propertyApiSlice";
import { publishImage } from "../../../../helpers/imageupload";
import { useDropzone } from "react-dropzone";
import Loader from "../../../../components/Loader";
const AddPersonalProperty = () => {
  const { name } = useSelector((state) => state.user);
  const [displayimg, setDisplayimg] = useState();
  const [isUploading, setIsUploading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const navigate = useNavigate();
  const [isloading, setIsloading] = useState(false);
  const [itemid, setItemid] = useState();
  const [shopCategory, setShopCategory] = useState();
  const [shopCategorytwo, setShopCategorytwo] = useState();
  const [data, setData] = useState({
    category: "",
    subCategoryid: ""
  })

  const Handledata = (e) => {
    setData((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value.split("."),
    }));
  };

  const categoryName = data?.category[1];
  const categoryid = data.category[0];
  const subcategoryName = data?.subCategoryid[1];
  const subcategoryid = data.subCategoryid[0];

  const [getConsumerCategories] = useLazyGetShopConsumerCategoriesQuery();
  const [createProperty] = useCreatePropertyMutation();

  const Firstcategory = () => {
    getConsumerCategories({ type: 'property', parentCategory: '' }).unwrap()
      .then((response) => {
        if (response?.success) {
          setShopCategory(response?.data?.Category);
        }
      })
      .catch((error) => {
        console.log("servicesCategories", error);
      });
  };

  const Mydata = () => {
    getConsumerCategories({ type: 'property', parentCategory: categoryName }).unwrap()
      .then((response) => {
        if (response?.success) {
          setShopCategorytwo(response?.data?.Category);
        }
      })
      .catch((error) => {
        console.log("servicesCategories", error);
      });
  };
  const onDrop = async (acceptedFiles) => {
    try {
      setIsUploading(true);
      setUploadProgress(0);

      const abc = await publishImage(acceptedFiles, (percent) => {
        setUploadProgress(percent);
      });
      setPropertyadd((propertyadd) => ({
        ...propertyadd,
        image: abc
      }));

      setDisplayimg(abc);

    } catch (error) {
      FailedNotify("Failed! Try Again");
    } finally {
      setIsUploading(false);
      setUploadProgress(0);
    }
  }

  const { getRootProps, getInputProps } = useDropzone({
    accept: "image/*",
    onDrop,
  });

  const [propertyadd, setPropertyadd] = useState({
    userid: name?._id,
    plottype: "",
    category: "",
    categoryid: "",
    subCategory: "",
    subCategoryid: "",
    country: "",
    city: "",
    state: "",
    area: "",
    price: "",
    saletype: "",
    email: "",
    currency: "",
    description: "",
    businessType: "singleAds",
    image: [""],
    status: true,
  });

  useEffect(() => {
    setPropertyadd((propertyadd) => ({
      ...propertyadd,
      category: categoryName,
      categoryid: categoryid,
      subCategory: subcategoryName,
      subCategoryid: subcategoryid

    }));

  }, [categoryid, categoryName, subcategoryName, subcategoryid]);


  const formSubmit = async (e) => {
    setIsloading(true);
    e.preventDefault();
    try {
      const payload = { ...propertyadd, userid: name?._id };
      const response = await createProperty(payload).unwrap();
      setItemid(response?.data?._id);

      if (response?.success) {
        setIsloading(false);
        setTimeout(() => {
          SuccessNotify("Add Posted SuccesFully...");
          navigate(`/personal-add`);
        }, 1000);
      }
    } catch (error) {
      setIsloading(false);
      FailedNotify("Failed to Post Try Again!");
    }
  };

  return (
    <div>
      <PropertyAdForm
        title="Add Personal Property Category,Location,Price,Description"
        butn="Post"
        navigateTo="/personal-add"
        back="/personal-add"
        propertyadd={propertyadd}
        setPropertyadd={setPropertyadd}
        handlerFunction={formSubmit}
        itemid={itemid}
        shopCategory={shopCategory}
        shopCategorytwo={shopCategorytwo}
        Mydata={Mydata}
        Handledata={Handledata}
        Firstcategory={Firstcategory}
        getInputProps={getInputProps}
        getRootProps={getRootProps}
        displayimg={displayimg}
        setDisplayimg={setDisplayimg}
        isUploading={isUploading}
        uploadProgress={uploadProgress}
      />
    </div>
  );
};
export default AddPersonalProperty;
